const getDocCompareSidebarState = () => {
  const storedValue = localStorage.getItem('docCompareSidebarVisible');
  return storedValue !== null ? JSON.parse(storedValue) : true;
};

const initialState = {
  docCompareSidebarVisible: getDocCompareSidebarState(),
};

export const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'DOCCOMPARE_SIDEBAR':
      return {
        ...state,
        docCompareSidebarVisible: action.payload,
      };
    default:
      return state;
  }
};

export const setDocCompareSidebar = (value) => {
  localStorage.setItem('docCompareSidebarVisible', JSON.stringify(value));

  return {
    type: 'DOCCOMPARE_SIDEBAR',
    payload: value,
  };
};

export const sidebarStateSelector = (state) => state.sidebarState;
